import * as types from 'store/modules/hrms6ke/mutation-types'
import hrms6ke from 'api/hrms6ke'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import hrms6keLabels from 'assets/labels/hrms6ke'
import { hrms6keColumns } from 'assets/columns/hrms6ke'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms6keLabels,
    columns: hrms6keColumns(),
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {},
    detail: {
      tab1: {
        dtestrt: '',
        timbstr: '',
        dteend: '',
        timbend: '',
        timdstr: '',
        timdend: '',
        timastr: '',
        timaend: '',
        codcomp: '',
        codcalen: '',
        codshift: ''
      },
      tab2: {
        total: 0,
        rows: []
      }
    },
    detailTab2InlineData: [],
    dropdowns: {
      codrem: {
        en: {},
        th: {}
      }
    }
  },
  getters: {
    [types.GET_HRMS6KE_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS6KE_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS6KE_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS6KE_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS6KE_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS6KE_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS6KE_DETAIL] (state) {
      return state.detail
    },
    [types.GET_HRMS6KE_DROPDOWNS] (state) {
      return state.dropdowns
    },
    [types.GET_HRMS6KE_DETAIL_INLINE_DATA] (state) {
      return state.detailTab2InlineData
    }
  },
  mutations: {
    [types.SET_HRMS6KE_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS6KE_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS6KE_COLUMNS] (state, { labels, dropdowns }) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        let dropdownSets = [{ key: 'typot', value: dropdowns.typot[keyLang] }]
        state.columns[keyLang].detailTab2Table = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2Table, labels[keyLang], dropdownSets)
      }
    },
    [types.SET_HRMS6KE_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS6KE_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRMS6KE_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS6KE_DETAIL] (state, data) {
      state.detail = data
    },
    [types.SET_HRMS6KE_DETAIL_TAB2_PROCESS] (state, data) {
      for (var i = 0; i < data.rows.length; i++) {
        data.rows[i].flgEdit = true
      }
      state.detail.tab2 = data
    },
    [types.SET_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID] (state, data) {
      let currentData = state.detail.tab2.rows
      let currentTotal = currentData.length
      for (var i = 0; i < data.rows.length; i++) {
        data.rows[i].flgEdit = true
        currentData[currentTotal + i] = data.rows[i]
      }
      state.detail.tab2 = {
        rows: currentData,
        total: currentTotal + data.rows.length
      }
    },
    [types.SET_HRMS6KE_DROPDOWNS] (state, data) {
      state.dropdowns = data
    },
    [types.SET_HRMS6KE_DETAIL_ADD_INLINE] (state, { data, param }) {
      let rowIndex = state.detail.tab2.rows.map(function (dataRow) {
        return dataRow.rowID
      }).indexOf(param.rowID)
      state.detail.tab2.rows[rowIndex].codempid = data.codempid
      state.detail.tab2.rows[rowIndex].desc_codempid = data.desc_codempid
      state.detail.tab2.rows[rowIndex].codshift = data.codshift
      state.detail.tab2.rows[rowIndex].v_staappr = data.v_staappr
    },
    [types.SET_HRMS6KE_DETAIL_INLINE_DATA] (state, detailTab2InlineData) {
      state.detailTab2InlineData = detailTab2InlineData
    }
  },
  actions: {
    [types.TOGGLE_HRMS6KE_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS6KE_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS6KE_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS6KE_COLUMNS_LABELS] ({ commit }) {
      hrms6ke.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_COLUMNS, { labels: data.labels, dropdowns: data.dropdowns })
          commit(types.SET_HRMS6KE_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS6KE_INDEX] ({ commit }, searchParams) {
      hrms6ke.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS6KE_INDEX, objData)
        })
    },
    [types.RECEIVED_HRMS6KE_CREATE] ({ commit }, searchDetail) {
      hrms6ke.getCreate(searchDetail)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS6KE_DETAIL] ({ commit }, searchDetail) {
      hrms6ke.getDetail(searchDetail)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS] ({ commit }, processParams) {
      hrms6ke.postDetailTab2Process(processParams)
        .then((response) => {
          let data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_DETAIL_TAB2_PROCESS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS6KE_DETAIL_TAB2_PROCESS, objData)
        })
    },
    [types.RECEIVED_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID] ({ commit }, processParams) {
      hrms6ke.postDetailTab2Process(processParams)
        .then((response) => {
          let data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS6KE_DETAIL_TAB2_PROCESS_CODEMPID, objData)
        })
    },
    [types.RECEIVED_HRMS6KE_DETAIL_ADD_INLINE] ({ commit }, param) {
      hrms6ke.getDetailTab2AddInline(param)
        .then((response) => {
          const codempidData = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_DETAIL_ADD_INLINE, { data: codempidData, param: param })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS6KE_DROPDOWNS] ({ commit }) {
      hrms6ke.getDropdowns()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS6KE_DROPDOWNS, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS6KE_SAVE] ({ commit, dispatch }, { searchIndex, detail, callback }) {
      swal({
        title: constLabels('confirmTitle'),
        text: '<span class="text-red">' + constLabels('msgConfirmOT') + '</span><br>' + constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        closeOnCancel: true,
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms6ke.postSave(detail)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS6KE_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
              if (detail.numotgen === undefined) {
                callback.toggle('index')
              } else {
                dispatch(types.RECEIVED_HRMS6KE_DETAIL, detail)
              }
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    },
    [types.POST_HRMS6KE_DELETE] ({ commit, dispatch }, { saveParams, searchParams }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmDelete'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel'),
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms6ke.postDelete(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS6KE_INDEX, searchParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
              dispatch(types.RECEIVED_HRMS6KE_INDEX, searchParams)
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms6ke/index.js